export default "__VITE_ASSET__FeOki_D4__"